import * as React from "react";
import PropTypes from 'prop-types';

const SvgQuickAddToCart = props => {
  if (props.id !== "_svgquickaddtocart") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 40 40" fill="none" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M16.5 29a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm13 0a2.5 2.5 0 110 5 2.5 2.5 0 010-5zM10.117 6a1.2 1.2 0 011.198 1.105l2.805 16.192h17.276l2.182-12.182a1.227 1.227 0 011.417-.99c.66.115 1.102.743.987 1.402l-.002.006-2.369 13.237c-.012.07-.03.135-.052.2-.16.538-.66.933-1.251.933H13.213c-.54 0-1.004-.329-1.202-.798a1.231 1.231 0 01-.097-.307L9.067 8.402H5.202a1.202 1.202 0 110-2.402h4.915zM23 7c.455 0 .947.364 1.006.838l.008.131v5.007h5.088c.496 0 .898.488.898 1.024 0 .476-.331.903-.75.985l-.162.015L24 14.999l.014 5.032-.014.174c-.076.452-.559.795-1 .795-.453 0-.932-.364-.99-.837l-.01-.132v-5.032L16.897 15c-.495 0-.897-.464-.897-1 0-.476.318-.926.736-1.009l.16-.015H22l.001-5.007.013-.174C22.091 7.343 22.56 7 23 7z" fill="#202020" /></svg>;
};

SvgQuickAddToCart.displayName = "_svgquickaddtocart";
SvgQuickAddToCart.propTypes = {
  id: PropTypes.string
};
SvgQuickAddToCart.defaultProps = {
  id: ''
};
export default SvgQuickAddToCart;